export const RestMethod = Object.freeze({
	imV2ChatLoad: 'im.v2.Chat.load',
	imV2ChatGetDialogId: 'im.v2.Chat.getDialogId',
	imV2ChatShallowLoad: 'im.v2.Chat.shallowLoad',
	imV2ChatLoadInContext: 'im.v2.Chat.loadInContext',
	imV2ChatLoadContext: 'im.v2.Chat.loadInContext',
	imV2ChatAdd: 'im.v2.Chat.add',
	imV2ChatUpdate: 'im.v2.Chat.update',
	imV2ChatDelete: 'im.v2.Chat.delete',
	imV2ChatUpdateAvatar: 'im.v2.Chat.updateAvatar',
	imV2ChatRead: 'im.v2.Chat.read',
	imV2ChatReadAll: 'im.v2.Chat.readAll',
	imV2ChatReadAllByType: 'im.v2.Chat.readByType',
	imV2ChatUnread: 'im.v2.Chat.unread',
	imV2ChatJoin: 'im.v2.Chat.join',
	imV2ChatDeleteUser: 'im.v2.Chat.deleteUser',
	imV2ChatExtendPullWatch: 'im.v2.Chat.extendPullWatch',
	imV2RecentChannelExtendPullWatch: 'im.v2.Recent.Channel.extendPullWatch',
	imV2ChatMessageGetContext: 'im.v2.Chat.Message.getContext',
	imV2ChatMessageSend: 'im.v2.Chat.Message.send',
	imV2ChatMessageList: 'im.v2.Chat.Message.list',
	imV2ChatMessageTail: 'im.v2.Chat.Message.tail',
	imV2ChatMessageRead: 'im.v2.Chat.Message.read',
	imV2ChatMessageMark: 'im.v2.Chat.Message.mark',
	imV2ChatMessageDelete: 'im.v2.Chat.Message.delete',
	imV2ChatMessageUpdate: 'im.v2.Chat.Message.update',
	imV2ChatMessageReactionAdd: 'im.v2.Chat.Message.Reaction.add',
	imV2ChatMessageReactionDelete: 'im.v2.Chat.Message.Reaction.delete',
	imV2ChatMessageReactionTail: 'im.v2.Chat.Message.Reaction.tail',
	imV2ChatMessagePin: 'im.v2.Chat.Message.pin',
	imV2ChatMessageUnpin: 'im.v2.Chat.Message.unpin',
	imV2ChatMessageTailViewers: 'im.v2.Chat.Message.tailViewers',
	imV2ChatMessageDeleteRichUrl: 'im.v2.Chat.Message.deleteRichUrl',
	imV2ChatMessageCommentInfoList: 'im.v2.Chat.Message.CommentInfo.list',
	imV2ChatAnchorRead: 'im.v2.Chat.Anchor.read',
	imV2ChatPinTail: 'im.v2.Chat.Pin.tail',
	imV2ChatMentionList: 'im.v2.Chat.Mention.list',
	imV2ChatListShared: 'im.v2.Chat.listShared',
	imV2ChatCommentSubscribe: 'im.v2.Chat.Comment.subscribe',
	imV2ChatCommentUnsubscribe: 'im.v2.Chat.Comment.unsubscribe',
	imV2ChatCommentReadAll: 'im.v2.Chat.Comment.readAll',
	imV2ChatAddManagers: 'im.v2.Chat.addManagers',
	imV2ChatDeleteManagers: 'im.v2.Chat.deleteManagers',
	imV2ChatMessageDisappear: 'im.v2.Chat.Message.disappear',
	imV2ChatSetMessagesAutoDeleteDelay: 'im.v2.Chat.setMessagesAutoDeleteDelay',
	imV2SettingsGeneralUpdate: 'im.v2.Settings.General.update',
	imV2SettingsNotifyUpdate: 'im.v2.Settings.Notify.update',
	imV2SettingsNotifySwitchScheme: 'im.v2.Settings.Notify.switchScheme',
	imV2DesktopLogout: 'im.v2.Desktop.logout',
	imV2UpdateState: 'im.v2.UpdateState.getStateData',
	imV2BetaEnable: 'im.v2.Beta.enable',
	imV2BetaDisable: 'im.v2.Beta.disable',
	imV2ChatTaskPrepare: 'im.v2.Chat.Task.prepare',
	imV2RecentChannelTail: 'im.v2.Recent.Channel.Tail',
	imV2RecentCollabTail: 'im.v2.Recent.Collab.Tail',
	imV2RecentExternalChatTail: 'im.v2.Recent.ExternalChat.Tail',
	imV2RecentTail: 'im.v2.Recent.tail',
	imV2ChatCopilotUpdateRole: 'im.v2.Chat.Copilot.updateRole',
	imV2ChatCopilotUpdateAiModel: 'im.v2.Chat.Copilot.updateEngine',
	imV2AccessCheck: 'im.v2.Access.check',
	imV2ChatMemberEntitiesList: 'im.v2.Chat.MemberEntities.list',
	imV2ChatInputActionNotify: 'im.v2.Chat.InputAction.notify',
	imV2DiskFileSave: 'im.v2.Disk.File.save',
	imV2ChatBotSendContext: 'im.v2.Chat.Bot.sendContext',
	imV2ChatMemberTail: 'im.v2.Chat.Member.tail',
	imV2DiskFileTranscribe: 'im.v2.Disk.File.transcribe',
	imV2ChatSharedLinkGetIndividual: 'im.v2.Chat.SharingLink.getIndividual',
	imV2ChatJoinByCode: 'im.v2.Chat.joinByCode',
	imV2ChatSharedLinkRevoke: 'im.v2.Chat.SharingLink.revoke',
	imV2ChatSharedLinkRegenerateIndividual: 'im.v2.Chat.SharingLink.regenerateIndividual',
	imV2ChatGuestLinkGenerate: 'im.v2.Guest.Link.generate',
	imV2ChatGuestLinkRegenerate: 'im.v2.Guest.Link.regenerate',
	imV2ChatGuestLinkRevoke: 'im.v2.Guest.Link.revoke',
	imV2ChatFilterUsersByParticipation: 'im.v2.Chat.Member.filterUsersByParticipation',
	imV2RecentPin: 'im.v2.Chat.pin',
	imV2RecentUnpin: 'im.v2.Chat.unpin',

	imV2StickerPackLoad: 'im.v2.Sticker.Pack.load',
	imV2StickerPackTail: 'im.v2.Sticker.Pack.tail',
	imV2StickerPackGet: 'im.v2.Sticker.Pack.get',
	imV2StickerPackAdd: 'im.v2.Sticker.Pack.add',
	imV2StickerPackDelete: 'im.v2.Sticker.Pack.delete',
	imV2StickerPackLink: 'im.v2.Sticker.Pack.link',
	imV2StickerPackUnlink: 'im.v2.Sticker.Pack.unlink',
	imV2StickerPackRename: 'im.v2.Sticker.Pack.rename',

	imV2StickerRecentDelete: 'im.v2.Sticker.Recent.delete',
	imV2StickerRecentDeleteAll: 'im.v2.Sticker.Recent.deleteAll',

	imV2StickerAdd: 'im.v2.Sticker.add',
	imV2StickerDelete: 'im.v2.Sticker.delete',

	imV2AnchorRead: 'im.v2.Anchor.read',

	imV2PromotionRead: 'im.v2.Promotion.read',

	imV2CallZoomCreate: 'im.v2.Call.Zoom.create',
	imCallBetaCreateRoom: 'im.call.beta.createRoom',

	imMessageAdd: 'im.message.add',
	imMessageCommand: 'im.message.command',

	imChatMute: 'im.chat.mute',
	imChatUpdateTitle: 'im.chat.updateTitle',
	imChatFileCollectionGet: 'im.chat.file.collection.get',
	imChatFileGet: 'im.chat.file.get',
	imChatUrlGet: 'im.chat.url.get',
	imChatUrlDelete: 'im.chat.url.delete',
	imChatTaskGet: 'im.chat.task.get',
	imChatTaskDelete: 'im.chat.task.delete',
	imChatCalendarGet: 'im.chat.calendar.get',
	imChatFavoriteAdd: 'im.chat.favorite.add',
	imChatFavoriteDelete: 'im.chat.favorite.delete',
	imChatFavoriteGet: 'im.chat.favorite.get',
	imChatFavoriteCounterGet: 'im.chat.favorite.counter.get',
	imChatUrlCounterGet: 'im.chat.url.counter.get',
	imChatPinGet: 'im.chat.pin.get',
	imChatPinAdd: 'im.chat.pin.add',
	imChatPinDelete: 'im.chat.pin.delete',
	imChatCalendarPrepare: 'im.chat.calendar.prepare',
	imChatCalendarAdd: 'im.chat.calendar.add',
	imChatCalendarDelete: 'im.chat.calendar.delete',
	imChatUserDelete: 'im.chat.user.delete',
	imChatUserAdd: 'im.chat.user.add',

	imDialogWriting: 'im.dialog.writing',
	imDialogUsersList: 'im.dialog.users.list',
	imDialogMessagesSearch: 'im.dialog.messages.search',

	imUserGet: 'im.user.get',
	imUserListGet: 'im.user.list.get',
	imUserStatusSet: 'im.user.status.set',
	imUserStatusIdleStart: 'im.user.status.idle.start',
	imUserStatusIdleEnd: 'im.user.status.idle.end',

	imDiskFolderGet: 'im.disk.folder.get',
	imDiskFolderListGet: 'im.disk.folder.list.get',
	imDiskFilePreviewUpload: 'disk.api.file.attachPreview',
	imDiskFileCommit: 'im.disk.file.commit',
	imDiskFileDelete: 'im.disk.file.delete',
	imDiskFileSave: 'im.disk.file.save',

	imRecentGet: 'im.recent.get',
	imRecentList: 'im.recent.list',
	imRecentPin: 'im.recent.pin',
	imRecentHide: 'im.recent.hide',

	imNotifyGet: 'im.notify.get',
	imNotifyRead: 'im.notify.read',
	imNotifyReadAll: 'im.notify.read.all',
	imV2NotifyRead: 'im.v2.Notify.read',
	imV2NotifyReadAll: 'im.v2.Notify.readAll',
	imNotifySchemaGet: 'im.notify.schema.get',
	imNotifyHistorySearch: 'im.notify.history.search',
	imNotifyAnswer: 'im.notify.answer',

	imCallBackgroundGet: 'call.Desktop.Background.get',
	imCallBackgroundCommit: 'call.Desktop.Background.commit',
	imCallBackgroundDelete: 'call.Desktop.Background.delete',
	imCallMaskGet: 'call.Desktop.Mask.get',
	imSmilesGet: 'smile.get',

	imPromotionRead: 'im.promotion.read',

	imBotGiphyListPopular: 'imbot.Giphy.listPopular',
	imBotGiphyList: 'imbot.Giphy.list',
	imBotDialogVote: 'imbot.dialog.vote',
	imBotNetworkChatCount: 'imbot.Network.Chat.count',
	imBotNetworkChatList: 'imbot.Network.Chat.list',
	imBotNetworkChatAdd: 'imbot.Network.Chat.add',

	linesDialogGet: 'imopenlines.dialog.get',

	socialnetworkCollabCreate: 'socialnetwork.collab.Collab.add',
	socialnetworkCollabUpdate: 'socialnetwork.collab.Collab.update',
	socialnetworkCollabDelete: 'socialnetwork.collab.Collab.delete',
	socialnetworkMemberAdd: 'socialnetwork.collab.Member.add',
	socialnetworkMemberDelete: 'socialnetwork.collab.Member.delete',
	socialnetworkMemberLeave: 'socialnetwork.collab.Member.leave',
	intranetInviteGetLinkByCollabId: 'intranet.invite.getLinkByCollabId',
	intranetInviteRegenerateLinkByCollabId: 'intranet.invite.regenerateLinkByCollabId',
	imV2McpSendSelectionHintOnce: 'aiassistant.api.McpHint.sendSelectionHintOnce',
});
